export default __webpack_public_path__ + "static/media/stu.eeb226ea.jpg";